var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "30%",
        "modal-append-to-body": true,
        "append-to-body": "",
        "close-on-click-modal": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "命中val", prop: "hitVal" } },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "请输入命中val" },
                model: {
                  value: _vm.form.hitVal,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "hitVal", $$v)
                  },
                  expression: "form.hitVal",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "类型", prop: "type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("用户")]),
                  _c("el-radio", { attrs: { label: "2" } }, [_vm._v("设备")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "云桌面封禁", prop: "cloudDeskFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.cloudDeskFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "cloudDeskFlag", $$v)
                    },
                    expression: "form.cloudDeskFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "云镜像封禁", prop: "cloudMirrorFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.cloudMirrorFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "cloudMirrorFlag", $$v)
                    },
                    expression: "form.cloudMirrorFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "好友分享封禁", prop: "friendShareFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.friendShareFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "friendShareFlag", $$v)
                    },
                    expression: "form.friendShareFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "局域网镜像封禁", prop: "lanMirrorFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.lanMirrorFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "lanMirrorFlag", $$v)
                    },
                    expression: "form.lanMirrorFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "本地音频封禁", prop: "localAudioFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.localAudioFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "localAudioFlag", $$v)
                    },
                    expression: "form.localAudioFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "本地图片封禁", prop: "localPicFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.localPicFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "localPicFlag", $$v)
                    },
                    expression: "form.localPicFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "本地视频封禁", prop: "localVideoFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.localVideoFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "localVideoFlag", $$v)
                    },
                    expression: "form.localVideoFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "在线音频封禁", prop: "onlineAudioFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.onlineAudioFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "onlineAudioFlag", $$v)
                    },
                    expression: "form.onlineAudioFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "在线图片封禁", prop: "onlinePicFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.onlinePicFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "onlinePicFlag", $$v)
                    },
                    expression: "form.onlinePicFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "在线视频封禁", prop: "onlineVideoFlag" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.onlineVideoFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "onlineVideoFlag", $$v)
                    },
                    expression: "form.onlineVideoFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  maxlength: "9999",
                  type: "textarea",
                  size: "small",
                  placeholder: "请输入备注",
                  clearable: "",
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "btn-container",
          staticStyle: { "text-align": "right", "margin-top": "20px" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }